module.exports = __webpack_public_path__ + "img/gridviewicon.5998dda3.svg";